import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { KeyDataPageComponent } from './key-data-page/key-data-page.component';
import { KeyDataRoutingModule } from './key-data-routing.module';
import { SharedModule } from '../../shared/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { DapUiModule } from 'dap-ui-library';
import { ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [KeyDataPageComponent],
  imports: [CommonModule, KeyDataRoutingModule, SharedModule, TranslateModule, DapUiModule, ReactiveFormsModule],
})
export class KeyDataModule {}
